module.exports = __webpack_public_path__ + "static/carpool-gallery-7-4ff3f170c42fdf7ae9ef53e31d4d3b64.jpg";